export default {"src":"/_next/static/media/sway-logo-purple.fa217c1d.svg","height":356,"width":940};